<template>
  <div id="EventsListPage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid third-bg">
        <div class="container-md">
          <div class="row">
            <div class="col-6">
              <h1>
                <span class="font-19 border-bottom-gold px-5">رویداد ها</span>
              </h1>
            </div>
            <div class="col-6 text-left">
              <v-btn color="primary" outlined @click="openCategoryBox">
                دسته بندی
                <i class="fa-solid fa-cubes-stacked fa-xl"></i>
              </v-btn>
            </div>

              <div v-for="(item,i) in events" :key="i" class="col-sm-6 col-lg-4 ">
                <router-link :to="{path:'ContentDetail' , query:{id : item.EventId , type: 1}}"
                             class="bg-white rounded-lg d-block">
                  <ContentCard :item="item"/>
                </router-link>
              </div>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 text-center">
                  <v-pagination
                      v-if="hasPagination"
                      v-model="pageIndex"
                      :length="totalLength"
                      :total-visible="24"
                      :value="pageIndex"
                      @input="onPageChange"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
          <div id="categoryBox" class="category-box bg-white p-2">
            <v-btn icon @click="closeCategoryBox">
              <i class="fa-solid fa-circle-xmark fa-xl"></i>
            </v-btn>
            <div class="row mx-2 third-bg rounded-lg ">
              <div class="col-3 "><i class="fa-solid fa-cubes-stacked fa-xl"></i></div>
              <div class="col-9 ">دسته بندی</div>
            </div>
            <div class="row mx-1">
              <div v-for="item in categoryList" :key="item.EventCategoryId" class="col-12 border-bottom">
                <router-link :to="{path:'EventsList',query:{id:item.EventCategoryId}}">
                  <span class="d-inline-block w-75">{{ item.Name }}</span>
                  <span class="d-inline-block w-25 text-left"><i class="fas fa-arrow-alt-left"></i></span>
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ContentCard from "@/Academy/components/ContentCard";
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "EventsList",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar, ContentCard},
  data: () => ({
    categoryList: [],
    events: [],
    showLoaderDialog: false,
    pageIndex: 1,
    totalLength: null,
    hasPagination: false,
  }),
  mounted() {
    this.getCategory()
  },
  watch: {
    '$route.query.id'() {
      location.reload()
    },
    "$route.query"() {
      if (this.$route.query.pageIndex !== undefined) {
        this.pageIndex = parseInt(this.$route.query.pageIndex);
      }else{
        this.pageIndex = 1;
      }
      this.getEvents();
    }
  },
  methods: {
    onPageChange() {
      this.updateQueryFields("pageIndex", this.pageIndex, true);
    },
    updateQueryFields(key, value, isPageChanged = false) {
      const queryList = {};
      Object.assign(queryList, this.$route.query);
      queryList[key] = value;
      //this.$router.push({path: this.$route.path,query: { ...this.$route.query, data: 'load' } });

      if(!isPageChanged){
        delete queryList.pageIndex;
      }
      this.$router.push({ query: queryList });

    },
    openCategoryBox() {
      document.getElementById('categoryBox').classList.add('open')
    },
    closeCategoryBox() {
      document.getElementById('categoryBox').classList.remove('open')
    },
    getCategory() {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/EventCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryList = JSON.parse(result)
            this.getEvents()
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getEvents() {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      var url = "/Client/Events?categoryId="
      if (this.$route.query.id !== undefined) {
        url += this.$route.query.id
      }
      if (this.$route.query.pageIndex !== undefined && this.$route.query.pageIndex !== "" && this.$route.query.pageIndex !== null) {
        url += "&pageIndex=" + this.$route.query.pageIndex;
      }
      if (this.pageSize !== null) {
        url += "&pageSize=" + "24";
      }

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let totalCount = json.totalCount;
            if (totalCount > 24) {
              this.totalLength = Math.ceil(totalCount / 24);
              this.hasPagination = true;
            } else {
              this.hasPagination = false;
            }
            this.events = json.list
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>
